// extracted by mini-css-extract-plugin
export default {"stats":"analytics_stats__BfwZ3","mainStat":"analytics_mainStat__Gn8xT","title":"analytics_title__IPOcB"};